/* Auto drop switch (Tuxedo Tiger Comics, Oct 23 2026).
 * The server already renders the current drop. This script only covers pages that were rendered
 * BEFORE a drop time (cached pages, open tabs): it reads the upcoming drops rendered into
 * [data-tt-drop-candidates] and, once a drop time passes, swaps the presale hero + announcement
 * to that drop. On /pages/presale ([data-tt-drop-redirect]) it then sends the visitor to the product.
 * Preview-only test: ?drop_test=2026-10-26T11:00:30-06:00 (ignored on the live/main theme).
 */
(function () {
  'use strict';
  if (window.__ttDropSwitch) return; window.__ttDropSwitch = true;
  var skew = 0;
  try {
    var q = new URLSearchParams(window.location.search).get('drop_test');
    var role = (window.Shopify && window.Shopify.theme && window.Shopify.theme.role) || '';
    if (q && role && role !== 'main') { var t = Date.parse(q); if (isFinite(t)) skew = t - Date.now(); }
  } catch (e) {}
  function now() { return Date.now() + skew; }

  function candidates() {
    var out = [], seen = {};
    document.querySelectorAll('script[data-tt-drop-candidates]').forEach(function (el) {
      var list; try { list = JSON.parse(el.textContent); } catch (e) { return; }
      (list || []).forEach(function (c) {
        if (!c || !isFinite(c.ts) || !c.url) return;
        var k = c.ts + '|' + c.url; if (seen[k]) return; seen[k] = 1; out.push(c);
      });
    });
    return out.sort(function (a, b) { return a.ts - b.ts; });
  }

  function swapHero(hero, c) {
    if (hero.getAttribute('data-tt-drop-applied') === String(c.ts)) return;
    hero.setAttribute('data-tt-drop-applied', String(c.ts));
    hero.setAttribute('data-tt-drop-url', c.url);
    hero.querySelectorAll('[data-tt-drop-link]').forEach(function (a) { a.href = c.url; });
    var h = hero.querySelector('[data-tt-drop-heading]'); if (h && c.heading) h.textContent = c.heading;
    var tx = hero.querySelector('[data-tt-drop-text]'); if (tx && c.text) tx.innerHTML = c.text;
    var sh = hero.querySelector('[data-tt-drop-ship]'); if (sh && c.ship) sh.textContent = c.ship;
    // Price and per-cover stock belong to the old product: hide them rather than show wrong numbers.
    hero.querySelectorAll('[data-tt-drop-price],[data-tt-drop-stock],.tt-countdown').forEach(function (el) { el.hidden = true; el.style.display = 'none'; });
    hero.querySelectorAll('.tt-hero__cover:not([data-tt-drop-cover])').forEach(function (el) { el.style.display = 'none'; });
    var cover = hero.querySelector('[data-tt-drop-cover] img');
    if (cover && c.img) { cover.removeAttribute('srcset'); cover.removeAttribute('sizes'); cover.src = c.img; cover.alt = c.heading || ''; }
  }
  function swapAnn(c) {
    document.querySelectorAll('[data-tt-drop-ann]').forEach(function (s) { if (c.ann) s.textContent = c.ann; });
    document.querySelectorAll('[data-tt-drop-ann-link]').forEach(function (a) { a.href = c.url; });
  }
  function redirect() {
    if (window.Shopify && window.Shopify.designMode) return;
    var hero = document.querySelector('[data-tt-drop-hero][data-tt-drop-redirect="true"]');
    if (!hero) return;
    var url = hero.getAttribute('data-tt-drop-url');
    if (url && url.charAt(0) === '/' && url.indexOf('/pages/presale') !== 0) window.location.replace(url);
  }

  var timer = null;
  function run() {
    clearTimeout(timer);
    var list = candidates(), n = now(), cur = null, next = null;
    list.forEach(function (c) { if (c.ts * 1000 <= n) cur = c; else if (!next) next = c; });
    if (cur) {
      document.querySelectorAll('[data-tt-drop-hero]').forEach(function (h) { swapHero(h, cur); });
      swapAnn(cur);
    }
    redirect();
    if (next) {
      var wait = next.ts * 1000 - n + 250;
      if (wait > 0 && wait < 2147483000) timer = setTimeout(run, wait);
    }
  }
  document.addEventListener('visibilitychange', function () { if (!document.hidden) run(); });
  document.addEventListener('shopify:section:load', function () { run(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
